import { Country, State } from "country-state-city";

export const getCountryName = (countryCode) => {
  if (!countryCode) return null;

  const country = Country.getCountryByCode(countryCode);
  return country?.name ?? countryCode;
};

export const getStateName = (countryCode, stateCode) => {
  if (!countryCode || !stateCode) return null;

  const state = State.getStateByCodeAndCountry(stateCode, countryCode);
  return state?.name ?? stateCode;
};

export const getLocationString = ({ city, state, country }) => {
  return [
    city,
    getStateName(country, state),
    getCountryName(country),
  ]
    .filter(Boolean)
    .join(", ");
};
